import { render, staticRenderFns } from "./EventParticipants.vue?vue&type=template&id=016c774c&"
import script from "./EventParticipants.vue?vue&type=script&lang=js&"
export * from "./EventParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports